import { v2gate, gate } from 'hub-http/gates';
export const HELP_DESK_ROUTING_SCOPE_FILTERING = v2gate('HelpDeskRoutingScopeFiltering');
export const USER_LEVEL_CAPACITY_LIMITS = gate('Routing:UserLevelCapacityLimits');
export const USER_LEVEL_CAPACITY_LIMITS_TICKET_TYPE = gate('Routing:UserLevelCapacityLimits:TicketType');
export const TEAMS_ONLY_ROUTING = gate('Routing:TeamsOnly');
export const ROUTING_AWAY_STATUS_TIMER = gate('Routing::AwayStatusTimer');
export const USAGE_BASED_BILLING_INBOUND_2025 = gate('UsageBasedBilling:Inbound2025');
export const CUSTOMER_AGENT_GLOBAL_HANDOFFS = gate('CustomerAgent:GlobalHandoff');